'use client';

import Link from 'next/link';
import { getSourcePath } from '@/rewrites';
import Logo from '@/components/common/Logo';

const PHONE = '+49 621 49086090';
const EMAIL = 'kontakt@vergabepilot.ai';

const Footer = () => {
  const imprintLink = getSourcePath('/imprint');
  const dataPrivacyLink = getSourcePath('/data-privacy');
  const termsOfUseLink = '/agb';
  const notionLink = 'https://www.notion.so/ciconia/Vergabepilot-AI-Handbuch-123a487d08fd8074b99dd182ef16dcf3?pvs=4';
  const blogLink = '/blog';
  const glossaryLink = getSourcePath('/glossary');

  const openCookiePreferences = () => {
    const CookieFirst = window.CookieFirst;
    if (CookieFirst) {
      CookieFirst.openPanel('cookies');
    }
  };

  return (
    <footer className="z-20 bg-base-200">
      <div className="page-layout flex flex-col gap-6 pb-4 pt-6 md:flex-row md:items-start md:justify-between">
        <div className="hidden items-center md:flex">
          <Logo compact />
        </div>

        <div className="flex flex-col gap-6 md:flex-row md:space-x-12">
          <div>
            <h3 className="mb-2 font-medium">Rechtliches</h3>
            <ul className="space-y-1.5">
              <li>
                <Link href={imprintLink} className="hover:underline">
                  Impressum
                </Link>
              </li>
              <li>
                <Link href={dataPrivacyLink} className="hover:underline">
                  Datenschutz
                </Link>
              </li>
              <li>
                <Link href={termsOfUseLink} className="hover:underline">
                  Nutzungsbedingungen
                </Link>
              </li>
              <li>
                <button onClick={openCookiePreferences} className="p-0 text-left hover:underline">
                  Cookies
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-2 font-medium">Ressourcen</h3>
            <ul className="space-y-1.5">
              <li>
                <Link href={blogLink} className="hover:underline">
                  Blog
                </Link>
              </li>
              <li>
                <Link href={glossaryLink} className="hover:underline">
                  Glossar
                </Link>
              </li>
              <li>
                <Link href={notionLink} target="_blank" rel="noopener noreferrer" className="hover:underline">
                  Hilfe-Center
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-2 font-medium">Kontakt</h3>
            <ul className="space-y-1.5">
              <li>
                <a href={`tel:${PHONE}`} className="hover:underline">
                  {PHONE}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} className="hover:underline">
                  {EMAIL}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="page-layout flex flex-col items-start justify-between gap-y-1 pb-4 pt-2 text-sm md:flex-row">
        <div className="flex items-center gap-2">
          <span>🇩🇪</span>
          <span>Made in Germany</span>
        </div>
        <div>© {new Date().getFullYear()} Ciconia Systems GmbH</div>
      </div>
    </footer>
  );
};

export default Footer;
